import {OotherSCWCActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const OotherSCWCRequestInit = () => {
    return {
        type: OotherSCWCActionType.OotherSCWC_INIT
    }
}

export const OotherSCWCSuccess = (
    objeckt: any
) => {
    return {
        type: OotherSCWCActionType.OotherSCWC_INIT,
        objeckt: objeckt
    }
}

export const getOotherSCWC = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            OotherSCWCSuccess(
                objeckt
            )
        )
    }
}
